import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { WagmiConfig } from 'wagmi'
import { wagmiConfig } from './helper/wagmi';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiConfig config={wagmiConfig}>
      <App />
    </WagmiConfig>
  </React.StrictMode>
);